"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _createStarExport(obj) { Object.keys(obj) .filter((key) => key !== "default" && key !== "__esModule") .forEach((key) => { if (exports.hasOwnProperty(key)) { return; } Object.defineProperty(exports, key, {enumerable: true, get: () => obj[key]}); }); } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; } var _class;// src/index.ts





var _core = require('@apollo/client/core'); _createStarExport(_core);
var _context = require('@apollo/client/link/context');
var _ws = require('@apollo/client/link/ws');
var _utilities = require('@apollo/client/utilities');
var _apollouploadclient = require('apollo-upload-client');
var _jscookie = require('js-cookie'); var _jscookie2 = _interopRequireDefault(_jscookie);
var _jwtdecode = require('jwt-decode'); var _jwtdecode2 = _interopRequireDefault(_jwtdecode);
var _crossfetch = require('cross-fetch'); var _crossfetch2 = _interopRequireDefault(_crossfetch);
var _subscriptionstransportws = require('subscriptions-transport-ws');

var ClemanClient = (_class = class {
  
  __init() {this.wsClient = null}
  __init2() {this._token = null}
  __init3() {this.isServer = typeof window === "undefined"}
  constructor(opts) {;_class.prototype.__init.call(this);_class.prototype.__init2.call(this);_class.prototype.__init3.call(this);
    const cache = new (0, _core.InMemoryCache)();
    const authLink = _context.setContext.call(void 0, (_, { headers }) => {
      return {
        headers: {
          ...headers,
          ...this.token ? { Authorization: "Bearer " + this.token } : {}
        }
      };
    });
    const uploadLink = _apollouploadclient.createUploadLink.call(void 0, {
      uri: _optionalChain([opts, 'optionalAccess', _2 => _2.baseURL]) ? opts.baseURL + "/graphql" : "/api/graphql",
      fetch: _crossfetch2.default
    });
    let link = _core.ApolloLink.from([authLink, uploadLink]);
    if (!this.isServer) {
      const uri = _optionalChain([opts, 'optionalAccess', _3 => _3.baseURL]) ? opts.baseURL + "/graphql" : location.origin + "/api/graphql";
      this.wsClient = new (0, _subscriptionstransportws.SubscriptionClient)(uri.replace(/^http(s?)/, "ws$1"), {
        lazy: true,
        inactivityTimeout: 60 * 1e3,
        reconnect: true,
        connectionParams: () => ({
          ...this.token ? { Authorization: "Bearer " + this.token } : {}
        })
      });
      const wsLink = new (0, _ws.WebSocketLink)(this.wsClient);
      link = _core.split.call(void 0, ({ query }) => {
        const definition = _utilities.getMainDefinition.call(void 0, query);
        return definition.kind === "OperationDefinition" && definition.operation === "subscription";
      }, wsLink, _core.ApolloLink.from([authLink, uploadLink]));
    }
    this.apollo = new (0, _core.ApolloClient)({
      link,
      cache,
      defaultOptions: {
        watchQuery: {
          fetchPolicy: "no-cache"
        },
        query: {
          fetchPolicy: "no-cache"
        },
        mutate: {
          fetchPolicy: "no-cache"
        }
      }
    });
  }
  get token() {
    if (!this.isServer) {
      const token = _jscookie2.default.get("cleword_token");
      if (token) {
        return token;
      }
    } else {
      return this._token;
    }
    return null;
  }
  set token(token) {
    if (!this.isServer) {
      if (token) {
        try {
          const payload = _jwtdecode2.default.call(void 0, token);
          _jscookie2.default.set("cleword_token", token, {
            expires: new Date(payload.exp * 1e3),
            secure: location.protocol.startsWith("https") ? true : void 0,
            sameSite: location.protocol.startsWith("https") ? "None" : void 0
          });
        } catch (err) {
          console.error(err);
        }
      } else {
        _jscookie2.default.remove("cleword_token");
      }
    } else {
      this._token = token;
    }
  }
}, _class);


exports.ClemanClient = ClemanClient;
//# sourceMappingURL=index.js.map
